module.exports = __webpack_public_path__ + "static/media/acceuil_6.b3b93706.jpg";